import {HttpStatusCodes} from '@naverpay/es-http-status-codes'
import axios, {AxiosRequestConfig, type AxiosError, type AxiosResponse} from 'axios'

import {isLocalProfile} from './env'

interface CreateAxiosInstanceParams {
    config?: AxiosRequestConfig
}

function responseInterceptor<T>(response: AxiosResponse<T>) {
    isLocalProfile &&
        // eslint-disable-next-line no-console
        console.log(
            `[API] ${response.config?.method} - ${response?.config?.baseURL}${response?.config?.url} (${response?.status})`,
        )

    return response
}

export function rejectInterceptor(error: AxiosError) {
    isLocalProfile &&
        // eslint-disable-next-line no-console
        console.log(
            `[API] ${error.config?.method} - ${error?.config?.baseURL}${error?.config?.url} (${
                error?.response?.status || HttpStatusCodes.INTERNAL_SERVER_ERROR
            })`,
        )
    throw error
}

export function createAxios({config}: CreateAxiosInstanceParams) {
    const instance = axios.create({
        ...config,
    })
    instance.interceptors.response.use(responseInterceptor, rejectInterceptor)

    return instance
}
